import { Component, OnInit, Input, Output, EventEmitter, SimpleChange, AfterViewInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CommonMethodService } from '../common-method.service';
import { addClass } from '@syncfusion/ej2-base';
import { GeneralService } from 'src/app/services/general.service';
import { IGetPermissionMandatoryField } from '../interface';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { EPropertyProtectionId } from '../enum';
import { DatePipe } from '@angular/common';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { ModalWrapperService } from 'src/app/services/modal-wrapper.service';
@Component({
    selector: 'app-property-protection',
    templateUrl: 'property-protection.component.html',
    styleUrls: ['property-protection.component.scss'],
    standalone: false
})
export class PropertyProtectionComponent implements OnInit, AfterViewInit {
  @Input() dayEndFacilityDate;
  @Input() NextDayendDate;
  @Input() MoveInDate;
  @Input() selectedInsuranceId: number;
  @Input() moduleType: number;
  @Input() CustomerPropertyProtectionList = [];
  @Input() NextBillingDate;
  @Input() facilityMoveInSettings;
  @Input() effectiveDatesList = [];
  @Input() propertyProtectionLabel: string;
  @Input() CurrentURCFromDate;
  @Output() emitSavePropertyProtect = new EventEmitter();
  @Output() emitPropProtInit = new EventEmitter();
  @Output() emitPropertyProtectionObject = new EventEmitter();
  subjectPolicyNo: Subject<any> = new Subject();
  subjectCompanyName: Subject<any> = new Subject();
  today = new Date();
  PropertyProtectionForm: FormGroup;
  mandateFields;
  propertyProtectionField: boolean;
  balanceField: boolean;
  policyNofield: boolean;
  todayField: boolean;
  effectiveDateField: boolean;
  sub: any;
  selecteddateoption: any;
  isInit = false;
  futureMovedIn = false;
  masterCustomerPropertyProtectionList = [];
  masterCustomerPropertyProtectionListOriginalCopy = [];
  initialSelectedInsuranceID: number;
  EPropertyProtectionId = EPropertyProtectionId;
  datepipe: DatePipe = new DatePipe('en');
  minDate;
  expEndDate;
  @ViewChild('propertyProtectionModal', { static: false }) propertyProtectionModal: ModalDirective;
  modalConfig = {
    backdrop: 'static',
    keyboard: false
  };

  constructor(private formBuilder: FormBuilder,
    private generalService: GeneralService,
    private commonMethodService: CommonMethodService,
    private modalWrapper: ModalWrapperService) { }

  ngOnInit() {
    this.PropertyProtectionForm = this.formBuilder.group({
      PropertyProtection: [''],
      Balance: [0],
      PolicyNo: ['', { value: '', disabled: true }],
      CompanyName: ['', { value: '', disabled: true }],
      ExpiryDate: [''],
      DateOption: [''],
      EffectiveDate: ['']
    });
    if (this.moduleType === 2) {
      this.setMandatoryField(169);
    }
    const selectedObj = this.CustomerPropertyProtectionList.find(o => o.SelectedInsurance === true);
    this.PropertyProtectionForm.get('DateOption').valueChanges.subscribe(val => {
      /// Values
      // 1 => Today
      // 2 => Effective Date
      if (val != this.selecteddateoption) {
        this.selecteddateoption = val;
        if (val == 1) {
          this.PropertyProtectionForm.controls['EffectiveDate'].disable();
          let dateInTodayOption = this.futureMovedIn ? (new Date(this.commonMethodService.getFormattedDate(this.MoveInDate))>new Date(this.commonMethodService.getFormattedDate(this.NextDayendDate))?new Date(this.commonMethodService.getFormattedDate(this.MoveInDate)):new Date(this.commonMethodService.getFormattedDate(this.CurrentURCFromDate)) ) : this.dayEndFacilityDate;
          this.PropertyProtectionForm.patchValue({
            EffectiveDate: new Date(dateInTodayOption)
          });
        } else if (val == 2) {
          this.PropertyProtectionForm.controls['EffectiveDate'].enable();
          if ((selectedObj && this.dayEndFacilityDate) || this.NextBillingDate) {
            this.PropertyProtectionForm.patchValue({
              EffectiveDate: (selectedObj && selectedObj.EffectiveDate && selectedObj.EffectiveDate > new Date(this.dayEndFacilityDate)) ? selectedObj.EffectiveDate :
                this.commonMethodService.getTimeZoneOffSetDate(this.NextBillingDate)
            });
          }
        }
      }
    });
    if (this.PropertyProtectionForm && this.CustomerPropertyProtectionList.length) {
      this.isInit = true;
      setTimeout(() => this.emitPropProtInit.emit(true), 1500);
    }
    this.masterCustomerPropertyProtectionList = JSON.parse(JSON.stringify(this.CustomerPropertyProtectionList));
    this.masterCustomerPropertyProtectionListOriginalCopy = JSON.parse(JSON.stringify(this.CustomerPropertyProtectionList));
    this.masterCustomerPropertyProtectionList.map(item => {
      item.EffectiveDate = item.EffectiveDate ? new Date(item.EffectiveDate) : '';
      item.ExpiryDate = item.ExpiryDate ? new Date(item.ExpiryDate) : '';
    });
    this.masterCustomerPropertyProtectionListOriginalCopy.map(item => {
      item.EffectiveDate = item.EffectiveDate ? new Date(item.EffectiveDate) : '';
      item.ExpiryDate = item.ExpiryDate ? new Date(item.ExpiryDate) : '';
    });
    this.subjectPolicyNo.pipe(debounceTime(500),distinctUntilChanged()).subscribe(event => {
      this.changeCompanyNamePolicyNo(event, 'PolicyNo');
    });
    this.subjectCompanyName.pipe(debounceTime(500),distinctUntilChanged()).subscribe(event => {
      this.changeCompanyNamePolicyNo(event, 'CompanyName');
    });
    if(selectedObj && selectedObj.Balance > 0)
    {
      this.PropertyProtectionForm.patchValue({
        Balance : selectedObj.Balance,
      });
    }
  }

  ngAfterViewInit() {
    if (!this.isInit) {
      setTimeout(() => this.emitPropProtInit.emit(true), 1500);
    }
  }

  setInitialValue() {
    const selectedObj = this.CustomerPropertyProtectionList.find(o => o.Id == this.selectedInsuranceId);
    if (selectedObj.EffectiveDate && selectedObj.EffectiveDate > new Date(this.dayEndFacilityDate)) {
      if (this.futureMovedIn && (new Date(this.commonMethodService.getFormattedDate(this.MoveInDate)) >= selectedObj.EffectiveDate)) {
        this.PropertyProtectionForm.patchValue({
          DateOption: '1',
          PropertyProtection: selectedObj.Id,
          Balance: selectedObj.Balance,
          PolicyNo: selectedObj.Id == EPropertyProtectionId.ProofOfInsurance ? (selectedObj.InsuranceNumber ? selectedObj.InsuranceNumber : '') : '',
          CompanyName: selectedObj.Id == EPropertyProtectionId.ProofOfInsurance ? (selectedObj.CompanyName ? selectedObj.CompanyName : '') : '',
          ExpiryDate: selectedObj.Id == EPropertyProtectionId.ProofOfInsurance ? (selectedObj.ExpiryDate ? selectedObj.ExpiryDate : '') : ''
        });
      } else {
        this.PropertyProtectionForm.patchValue({
          DateOption: '2',
          Balance: selectedObj.Balance,
          PropertyProtection: selectedObj.Id,
          PolicyNo: selectedObj.Id == EPropertyProtectionId.ProofOfInsurance ? (selectedObj.InsuranceNumber ? selectedObj.InsuranceNumber : '') : '',
          CompanyName: selectedObj.Id == EPropertyProtectionId.ProofOfInsurance ? (selectedObj.CompanyName ? selectedObj.CompanyName : '') : '',
          ExpiryDate: selectedObj.Id == EPropertyProtectionId.ProofOfInsurance ? (selectedObj.ExpiryDate ? selectedObj.ExpiryDate : '') : ''
        });
      }
    } else {
      this.PropertyProtectionForm.patchValue({
        DateOption: '1',
        PropertyProtection: selectedObj.Id,
        Balance: selectedObj.Balance,
        PolicyNo: selectedObj.Id == EPropertyProtectionId.ProofOfInsurance ? (selectedObj.InsuranceNumber ? selectedObj.InsuranceNumber : '') : '',
        CompanyName: selectedObj.Id == EPropertyProtectionId.ProofOfInsurance ? (selectedObj.CompanyName ? selectedObj.CompanyName : '') : '',
        ExpiryDate: selectedObj.Id == EPropertyProtectionId.ProofOfInsurance ? (selectedObj.ExpiryDate ? selectedObj.ExpiryDate : '') : ''
      });
    }
    if (selectedObj.Id == EPropertyProtectionId.ProofOfInsurance) {
      this.PropertyProtectionForm.controls['CompanyName'].enable();
      this.PropertyProtectionForm.controls['PolicyNo'].enable();
      this.setMinMaxExpDate();
    } else {
      this.PropertyProtectionForm.controls['CompanyName'].disable();
      this.PropertyProtectionForm.controls['PolicyNo'].disable();
    }
  }

  onchangePPDateOption(val) {
    if (val != this.selecteddateoption) {
      this.selecteddateoption = val;
      const selectedObj = this.CustomerPropertyProtectionList.find(o => o.SelectedInsurance === true);
      if (val == 1) {
        this.PropertyProtectionForm.controls['EffectiveDate'].disable();
        let dateInTodayOption = this.futureMovedIn ? (new Date(this.commonMethodService.getFormattedDate(this.MoveInDate))>new Date(this.commonMethodService.getFormattedDate(this.NextDayendDate))?new Date(this.commonMethodService.getFormattedDate(this.MoveInDate)):new Date(this.commonMethodService.getFormattedDate(this.CurrentURCFromDate)) ) : this.dayEndFacilityDate;
        this.PropertyProtectionForm.patchValue({
          EffectiveDate: new Date(dateInTodayOption)
        });
      } else if (val == 2) {
        this.PropertyProtectionForm.controls['EffectiveDate'].enable();
        this.PropertyProtectionForm.patchValue({
          EffectiveDate: (selectedObj && selectedObj.EffectiveDate && selectedObj.EffectiveDate > new Date(this.dayEndFacilityDate)) ? selectedObj.EffectiveDate :
            this.commonMethodService.getTimeZoneOffSetDate(this.NextBillingDate)
        });
      }
      if (this.moduleType === 2) {
        const originalInsWithoutChange = this.verifyInsUpdatedOrChanged(selectedObj);
        if (!originalInsWithoutChange) {
          const obj = {
            propObj: selectedObj,
            PolicyNo: this.PropertyProtectionForm.get('PolicyNo').value,
            EffectiveDate: this.PropertyProtectionForm.get('EffectiveDate').value,
            InsuranceEffectiveFrom: val,
            IsPropObjError: this.isSelectedPropertyProtectionError(selectedObj)
          };
          this.emitPropertyProtectionObject.emit(obj);
        } else {
          this.emitPropertyProtectionObject.emit(null);
        }
      }
    }
  }

  onChangePP(eve) {
    this.selectedInsuranceId = eve.target.value;
    this.setInitialValue();
    const propObj = this.CustomerPropertyProtectionList.find(o => o.Id == eve.target.value);
    if (propObj) {
      this.PropertyProtectionForm.patchValue({
        Balance: propObj.Balance,
        PolicyNo: propObj.Id == EPropertyProtectionId.ProofOfInsurance ? (propObj.InsuranceNumber ? propObj.InsuranceNumber : '') : '',
        CompanyName: propObj.Id == EPropertyProtectionId.ProofOfInsurance ? (propObj.CompanyName ? propObj.CompanyName : '') : '',
        ExpiryDate: propObj.Id == EPropertyProtectionId.ProofOfInsurance ? (propObj.ExpiryDate ? propObj.ExpiryDate : '') : ''
      });
      this.CustomerPropertyProtectionList.map((ele) => { ele.SelectedInsurance = false; });
      propObj.SelectedInsurance = true;
      if (this.moduleType === 2) {
        let saveObj = null;
        const originalInsWithoutChange = this.verifyInsUpdatedOrChanged(propObj);
        if (!originalInsWithoutChange) {
          saveObj = {
            propObj: propObj,
            PolicyNo: this.PropertyProtectionForm.get('PolicyNo').value,
            EffectiveDate: this.PropertyProtectionForm.get('EffectiveDate').value,
            InsuranceEffectiveFrom: this.PropertyProtectionForm.get('DateOption').value,
            IsPropObjError: this.isSelectedPropertyProtectionError(propObj)
          };
        }
        this.emitPropertyProtectionObject.emit(saveObj);
      }
    }
    this.disableEffectiveDate();
  }

  isSelectedPropertyProtectionError(propObj) {
    if (propObj && propObj.Id == EPropertyProtectionId.ProofOfInsurance && (!propObj.InsuranceNumber || !propObj.CompanyName || !propObj.ExpiryDate)) {
      return true;
    }
    return false;
  }

  verifyInsUpdatedOrChanged(propObj) {
    const objOriginal = this.masterCustomerPropertyProtectionListOriginalCopy.find(o => o.Id == this.selectedInsuranceId);
    let originalInsWithoutChange = false; // to know if original ins is update or scheme is changed
    if (propObj && this.PropertyProtectionForm.get('PropertyProtection').value == this.initialSelectedInsuranceID) {
      const tempPPEffectiveDate = this.PropertyProtectionForm.get('EffectiveDate').value ? this.datepipe.transform(this.PropertyProtectionForm.get('EffectiveDate').value, 'MM/dd/yyyy') : '';
      const tempPPEffectiveDateInitial = (objOriginal && objOriginal.EffectiveDate) ? this.datepipe.transform(objOriginal.EffectiveDate, 'MM/dd/yyyy') : '';

      if (this.PropertyProtectionForm.get('PropertyProtection').value == EPropertyProtectionId.ProofOfInsurance) {
        let PofOriginal = this.masterCustomerPropertyProtectionListOriginalCopy.find(o => o.Id == EPropertyProtectionId.ProofOfInsurance);
        const tempPPEffectiveDatePOI = (PofOriginal && PofOriginal.EffectiveDate) ? this.datepipe.transform(PofOriginal.EffectiveDate, 'MM/dd/yyyy') : '';

        if (PofOriginal && this.PropertyProtectionForm.get('PolicyNo').value !== PofOriginal.InsuranceNumber) {
          originalInsWithoutChange = false;
        } else if (PofOriginal && this.PropertyProtectionForm.get('CompanyName').value !== PofOriginal.CompanyName) {
          originalInsWithoutChange = false;
        } else if (PofOriginal && PofOriginal.ExpiryDate && this.PropertyProtectionForm.get('ExpiryDate').value !== new Date(PofOriginal.ExpiryDate)) {
          originalInsWithoutChange = false;
        } else if (PofOriginal && tempPPEffectiveDate !== tempPPEffectiveDatePOI) {
          originalInsWithoutChange = false;
        } else {
          originalInsWithoutChange = true;
        }
      } else if (!propObj.isFutureEffectiveIns) {
        originalInsWithoutChange = true;
      } else if (objOriginal && tempPPEffectiveDate == tempPPEffectiveDateInitial) {
        originalInsWithoutChange = true;
      }
    }
    return originalInsWithoutChange
  }

  changeCompanyNamePolicyNo(event, type) {
    const propObj = this.CustomerPropertyProtectionList.find(o => o.SelectedInsurance);
    if (propObj) {
      if (type == 'CompanyName') {
        propObj.CompanyName = event.target.value;
      } else if (type == 'PolicyNo') {
        propObj.InsuranceNumber = event.target.value;
      }
      let saveObj = null;
      const originalInsWithoutChange = this.verifyInsUpdatedOrChanged(propObj);
      if (!originalInsWithoutChange) {
        saveObj = {
          propObj: propObj,
          PolicyNo: this.PropertyProtectionForm.get('PolicyNo').value,
          EffectiveDate: this.PropertyProtectionForm.get('EffectiveDate').value,
          InsuranceEffectiveFrom: this.PropertyProtectionForm.get('DateOption').value,
          IsPropObjError: this.isSelectedPropertyProtectionError(propObj),
          DoNotCallApi: true
        };
      }
      this.emitPropertyProtectionObject.emit(saveObj);
    }
  }

  changeExpiryDate(event) {
    if (event && event.isInteracted) {
      const propObj = this.CustomerPropertyProtectionList.find(o => o.SelectedInsurance);
      if (propObj) {
        propObj.ExpiryDate = event.value;
        let saveObj = null;
        const originalInsWithoutChange = this.verifyInsUpdatedOrChanged(propObj);
        if (!originalInsWithoutChange) {
          saveObj = {
            propObj: propObj,
            PolicyNo: this.PropertyProtectionForm.get('PolicyNo').value,
            EffectiveDate: this.PropertyProtectionForm.get('EffectiveDate').value,
            InsuranceEffectiveFrom: this.PropertyProtectionForm.get('DateOption').value,
            IsPropObjError: this.isSelectedPropertyProtectionError(propObj),
            DoNotCallApi: true
          };
        }
        this.emitPropertyProtectionObject.emit(saveObj);
      }
    }
  }

  changeDate(event) {
    // this method to trigger auto save for module 2
    if (event && event.isInteracted && this.moduleType === 2) {
      const propObj = this.CustomerPropertyProtectionList.find(o => o.SelectedInsurance);
      const originalInsWithoutChange = this.verifyInsUpdatedOrChanged(propObj);
      if (propObj && !originalInsWithoutChange) {
        const obj = {
          propObj: propObj,
          PolicyNo: this.PropertyProtectionForm.get('PolicyNo').value,
          EffectiveDate: event.value,
          InsuranceEffectiveFrom: this.PropertyProtectionForm.get('DateOption').value,
          IsPropObjError: this.isSelectedPropertyProtectionError(propObj)
        };
        this.emitPropertyProtectionObject.emit(obj);
      } else {
        this.emitPropertyProtectionObject.emit(null);
      }
    }
  }

  ngOnChanges(changes: SimpleChange) {
    if (changes['NextDayendDate'] || changes['MoveInDate'] || changes['CustomerPropertyProtectionList']) {
      if (this.NextDayendDate && this.MoveInDate) {
        this.isFutureMovein(this.NextDayendDate, this.MoveInDate,this.CurrentURCFromDate);
      }
      if (this.CustomerPropertyProtectionList && this.CustomerPropertyProtectionList.length && this.masterCustomerPropertyProtectionList &&
        this.masterCustomerPropertyProtectionList.length == 0) { // master list not set from ngOnInit then should be set here once
        this.masterCustomerPropertyProtectionList = JSON.parse(JSON.stringify(this.CustomerPropertyProtectionList));
        this.masterCustomerPropertyProtectionListOriginalCopy = JSON.parse(JSON.stringify(this.CustomerPropertyProtectionList));
        this.masterCustomerPropertyProtectionList.map(item => {
          item.EffectiveDate = item.EffectiveDate ? new Date(item.EffectiveDate) : '';
          item.ExpiryDate = item.ExpiryDate ? new Date(item.ExpiryDate) : '';
        });
        this.masterCustomerPropertyProtectionListOriginalCopy.map(item => {
          item.EffectiveDate = item.EffectiveDate ? new Date(item.EffectiveDate) : '';
          item.ExpiryDate = item.ExpiryDate ? new Date(item.ExpiryDate) : '';
        });
      }
    }
  }

  onLoadEffectiveDate(args: any) {
    if (this.futureMovedIn) {
      let moveinDate = this.getTimeZoneOffSetDate(this.MoveInDate);
      let dateList = [];
      dateList.push(new Date(moveinDate.getFullYear(), moveinDate.getMonth(), moveinDate.getDate()));
      this.effectiveDatesList = dateList.concat(this.effectiveDatesList);
    }

    const Dateindex = this.effectiveDatesList.findIndex(o => o.getDate() === args.date.getDate()
      && o.getMonth() === args.date.getMonth());
    var currentdate = this.today;
    currentdate.setHours(0, 0, 0, 0);
    var argsdate = args.date;
    argsdate.setHours(0, 0, 0, 0)
    if (Dateindex === -1 || argsdate < currentdate) {
      args.isDisabled = true;
    } else if (this.selecteddateoption == 1 && argsdate != currentdate) {
      args.isDisabled = true;
    } else {
      addClass([args.element], ['reservationCls']);
      args.element.firstElementChild.setAttribute('title', 'Next Billing Date');
      args.element.setAttribute('title', 'Next Billing Date');
    }
  }

  savePropertyProtection() {
    const obj = this.CustomerPropertyProtectionList.find(o => o.SelectedInsurance === true);
    const originalInsWithoutChange = this.verifyInsUpdatedOrChanged(obj);
    if (obj && !originalInsWithoutChange) {
      obj.EffectiveDate = this.PropertyProtectionForm.get('EffectiveDate').value;
      obj.Balance = this.PropertyProtectionForm.get('Balance').value;
      obj.CompanyName = this.PropertyProtectionForm.get('CompanyName').value;
      obj.InsuranceNumber = this.PropertyProtectionForm.get('PolicyNo').value;
      obj.ExpiryDate = this.PropertyProtectionForm.get('PropertyProtection').value == EPropertyProtectionId.ProofOfInsurance ? this.PropertyProtectionForm.get('ExpiryDate').value : '';
      obj['InsuranceEffectiveFrom'] = this.PropertyProtectionForm.get('DateOption').value;
      this.emitSavePropertyProtect.emit(obj);
    } else {
      this.emitSavePropertyProtect.emit(null);
    }
    this.masterCustomerPropertyProtectionList = JSON.parse(JSON.stringify(this.CustomerPropertyProtectionList));
    this.masterCustomerPropertyProtectionList.map(item => {
      item.EffectiveDate = item.EffectiveDate ? new Date(item.EffectiveDate) : '';
      item.ExpiryDate = item.ExpiryDate ? new Date(item.ExpiryDate) : '';
    });
  }

  setMandatoryField(formId: number) {
    this.generalService.GetMandatoryFieldsById(null, formId)
      .subscribe((response: IGetPermissionMandatoryField) => {
        this.mandateFields = response;
        this.propertyProtectionField = this.mandateFields.Form.ListOfProperties.find(o => o.Name === 'PropertyProtection').Required;
        this.balanceField = this.mandateFields.Form.ListOfProperties.find(o => o.Name === 'PropertyProtection').Required;
        this.policyNofield = this.mandateFields.Form.ListOfProperties.find(o => o.Name === 'PropertyProtection').Required;
        this.todayField = this.mandateFields.Form.ListOfProperties.find(o => o.Name === 'PropertyProtection').Required;
        this.effectiveDateField = this.mandateFields.Form.ListOfProperties.find(o => o.Name === 'PropertyProtection').Required;
        this.mandateFields.Form.ListOfProperties.forEach(field => {
          if (field.Name != 'Today') { // this field is not used in Angular form: EffectiveDate/Today are Radio options
            if (field.Required) {
              if (this.PropertyProtectionForm.get(field.Name))
                this.PropertyProtectionForm.get(field.Name).setValidators([Validators.required]);
            } else {
              if (this.PropertyProtectionForm.get(field.Name))
                this.PropertyProtectionForm.get(field.Name).setValidators(null);
            }
            this.PropertyProtectionForm.get(field.Name).updateValueAndValidity();
          }
        });
      });
  }

  ngOnDestroy(): void {
    if (this.sub) {
      this.sub.unsubscribe()
    }
  }

  isFutureMovein(NextDayendDate, MoveInDate,CurrentURCFromDate?) {
    let tempNextDayendDate = this.commonMethodService.getFormattedDate(NextDayendDate);
    let tempMoveInDate = this.commonMethodService.getFormattedDate(MoveInDate);
    let tempLatestURCFromDate = this.commonMethodService.getFormattedDate(CurrentURCFromDate);
    if (new Date(tempMoveInDate) > new Date(tempNextDayendDate) ) {
      this.futureMovedIn = true;
      if (this.PropertyProtectionForm) {
        this.PropertyProtectionForm.controls['DateOption'].enable();

        if (this.CustomerPropertyProtectionList && this.CustomerPropertyProtectionList.length > 0) {
          const selectedObj = this.CustomerPropertyProtectionList.find(o => o.SelectedInsurance);
          if (selectedObj && selectedObj.EffectiveDate && selectedObj.EffectiveDate > new Date(tempNextDayendDate)) {
            if (new Date(tempMoveInDate) >= selectedObj.EffectiveDate) {
              this.PropertyProtectionForm.patchValue({
                DateOption: '1',
                EffectiveDate: new Date(tempMoveInDate)
              });
              selectedObj.EffectiveDate = new Date(tempMoveInDate);
            }
          } else {
            this.PropertyProtectionForm.controls['EffectiveDate'].disable();
            this.PropertyProtectionForm.patchValue({
              DateOption: '1',
              EffectiveDate: new Date(tempMoveInDate)
            });
            selectedObj.EffectiveDate = new Date(tempMoveInDate);
          }
        } else {
          this.PropertyProtectionForm.controls['EffectiveDate'].disable();
          this.PropertyProtectionForm.patchValue({
            DateOption: '1',
            EffectiveDate: new Date(tempMoveInDate)
          });
        }
      }
    } else if(new Date(tempLatestURCFromDate) > new Date(tempNextDayendDate)){
      this.futureMovedIn = true;
      if (this.PropertyProtectionForm) {
        this.PropertyProtectionForm.controls['DateOption'].enable();

        if (this.CustomerPropertyProtectionList && this.CustomerPropertyProtectionList.length > 0) {
          const selectedObj = this.CustomerPropertyProtectionList.find(o => o.SelectedInsurance);
          if (selectedObj && selectedObj.EffectiveDate && selectedObj.EffectiveDate > new Date(tempNextDayendDate)) {
            if (new Date(tempLatestURCFromDate) >= selectedObj.EffectiveDate) {
              this.PropertyProtectionForm.patchValue({
                DateOption: '1',
                EffectiveDate: new Date(tempLatestURCFromDate)
              });
              selectedObj.EffectiveDate = new Date(tempLatestURCFromDate);
            }
          } else {
            this.PropertyProtectionForm.controls['EffectiveDate'].disable();
            this.PropertyProtectionForm.patchValue({
              DateOption: '1',
              EffectiveDate: new Date(tempLatestURCFromDate)
            });
            selectedObj.EffectiveDate = new Date(tempLatestURCFromDate);
          }
        } else {
          this.PropertyProtectionForm.controls['EffectiveDate'].disable();
          this.PropertyProtectionForm.patchValue({
            DateOption: '1',
            EffectiveDate: new Date(tempLatestURCFromDate)
          });
        }
      }
    }
    else {
      this.futureMovedIn = false;
    }
  }

  getTimeZoneOffSetDate(date) {
    let givenDate = new Date(date);
    return new Date(givenDate.getTime() + Math.abs(givenDate.getTimezoneOffset() * 60000));
  }

  disableSave() {
    if (this.PropertyProtectionForm.get('PropertyProtection').value == EPropertyProtectionId.ProofOfInsurance && (!this.PropertyProtectionForm.get('PolicyNo').value || !this.PropertyProtectionForm.get('CompanyName').value || !this.PropertyProtectionForm.get('ExpiryDate').value)) {
      return true;
    } else if (this.PropertyProtectionForm.valid && (this.PropertyProtectionForm.touched || this.PropertyProtectionForm.dirty)) {
      return false;
    } else {
      return true;
    }
  }

  disableEffectiveDate() {
    const selectedObj = this.CustomerPropertyProtectionList.find(o => o.Id == this.selectedInsuranceId);
    let isDisable = false;
    if (!this.futureMovedIn && this.PropertyProtectionForm.get('PropertyProtection').value == this.initialSelectedInsuranceID && selectedObj && !selectedObj.isFutureEffectiveIns) {
      isDisable = true;
    }
    if (isDisable) {
      this.PropertyProtectionForm.controls['DateOption'].disable();
      this.PropertyProtectionForm.controls['EffectiveDate'].disable();
    } else {
      this.PropertyProtectionForm.controls['DateOption'].enable();
      if (this.selecteddateoption == 1) {
        this.PropertyProtectionForm.controls['EffectiveDate'].disable();
      } else {
        this.PropertyProtectionForm.controls['EffectiveDate'].enable();
      }
    }
  }

  cancelPropertyProtection() {
    this.CustomerPropertyProtectionList = JSON.parse(JSON.stringify(this.masterCustomerPropertyProtectionList));
    this.CustomerPropertyProtectionList.map(item => {
      item.EffectiveDate = item.EffectiveDate ? new Date(item.EffectiveDate) : '';
      item.ExpiryDate = item.ExpiryDate ? new Date(item.ExpiryDate) : '';
    });
    const propObj = this.CustomerPropertyProtectionList.find(o => o.SelectedInsurance === true);
    this.selectedInsuranceId = propObj.Id;
    this.setInitialValue();
    this.disableEffectiveDate();
  }

  setMinMaxExpDate() {
    const date = new Date(this.dayEndFacilityDate);
    date.setHours(0, 0, 0, 0);
    this.minDate = date;
    const offset = date.getTimezoneOffset() * 60 * 1000;
    this.expEndDate = new Date(date.getTime() + offset +
      (this.facilityMoveInSettings.FutureDaysAllowedForExpiry) * 24 * 60 * 60 * 1000);
  }

  openModal() {
    if (this.propertyProtectionModal) {
      this.modalWrapper.openDirective(this.propertyProtectionModal);
    }
  }

  closeModal() {
    if (this.propertyProtectionModal) {
      this.propertyProtectionModal.hide();
    }
  }
}
